import { useCallback, useState } from 'react';

import type { Question, QuestionnaireAnswers } from '@shared';

interface UseParagraphQuestionOptions {
  question: Question;
  initialValue: string;
  onSubmit: (patch: Partial<QuestionnaireAnswers>) => Promise<void> | void;
}

export interface ParagraphQuestionState {
  value: string;
  setValue: (next: string) => void;
  isValid: boolean;
  submit: () => Promise<void>;
}

export function useParagraphQuestion({
  question,
  initialValue,
  onSubmit,
}: UseParagraphQuestionOptions): ParagraphQuestionState {
  const [value, setValue] = useState<string>(initialValue);
  const isValid = question.required ? value.trim().length > 0 : true;

  const submit = useCallback(async () => {
    if (!isValid) return;

    const trimmed = value.trim();

    await onSubmit(trimmed ? ({ [question.id]: trimmed } as Partial<QuestionnaireAnswers>) : {});
  }, [isValid, question.id, value, onSubmit]);

  return { value, setValue, isValid, submit };
}
